/* RISERSMART theme behaviour — vanilla, dependency-free */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  /* ---------- Mobile nav drawer ---------- */
  var navDrawer = document.getElementById('NavDrawer');
  document.querySelectorAll('[data-nav-open]').forEach(function (b) {
    b.addEventListener('click', function () { if (navDrawer) navDrawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
  });
  document.querySelectorAll('[data-nav-close]').forEach(function (b) {
    b.addEventListener('click', function () { if (navDrawer) navDrawer.classList.remove('is-open'); document.body.style.overflow = ''; });
  });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.getElementById('CartDrawer');
  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
  document.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); if (navDrawer) navDrawer.classList.remove('is-open'); document.body.style.overflow = ''; } });

  function money(cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: window.RS_CURRENCY || 'INR', maximumFractionDigits: 0 }).format(cents / 100); }
    catch (e) { return '₹' + (cents / 100).toFixed(0); }
  }

  function refreshCart() {
    var body = cartDrawer && cartDrawer.querySelector('[data-cart-body]');
    if (!body) return;
    body.innerHTML = '<div class="spinner"></div>';
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        if (!cart.items.length) {
          body.innerHTML = '<p class="lede" style="padding:2rem 0">Your enquiry list is empty.</p><a class="btn btn--block" href="/collections/all">Browse catalogue</a>';
          return;
        }
        var html = cart.items.map(function (i) {
          return '<div class="cart-line"><img src="' + (i.image ? i.image.replace(/(\.[^.]+)$/, '_120x120$1') : '') + '" alt="' + i.product_title + '"><div><div class="pcard__vendor">' + (i.vendor || '') + '</div><div style="font-weight:600">' + i.product_title + '</div><div class="pcard__meta">Qty ' + i.quantity + '</div></div><div style="font-family:var(--display);font-weight:900">' + money(i.line_price) + '</div></div>';
        }).join('');
        html += '<div class="cart-foot"><div class="cart-foot__row"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div><p class="moq-note">Taxes (GST) &amp; shipping calculated at checkout.</p><a class="btn btn--block" href="/checkout">Proceed to enquiry / checkout</a><a class="link-arrow" style="margin-top:1rem;display:inline-flex" href="/cart">View full cart</a></div>';
        body.innerHTML = html;
      })
      .catch(function () { body.innerHTML = '<p class="lede">Couldn\u2019t load your cart. <a href="/cart" style="text-decoration:underline">Open cart page</a>.</p>'; });
  }

  function updateCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n; el.style.display = n > 0 ? 'flex' : 'none';
    });
  }

  /* AJAX add-to-cart on any [data-add-to-cart] form */
  document.querySelectorAll('form[data-add-to-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      if (btn) { btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; btn.disabled = true; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () { openCart(); })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) { btn.textContent = btn.dataset.label || 'Add'; btn.disabled = false; } });
    });
  });

  /* prime the badge on load */
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); }).catch(function () {});

  /* ---------- Sticky header hide-on-scroll ---------- */
  var header = document.querySelector('.site-header');
  var lastY = 0;
  window.addEventListener('scroll', function () {
    if (!header) return;
    var y = window.pageYOffset;
    if (y > lastY && y > 240) header.classList.add('is-hidden');
    else header.classList.remove('is-hidden');
    lastY = y;
  }, { passive: true });

  /* ---------- Scroll reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll('.qty').forEach(function (q) {
    var input = q.querySelector('input');
    q.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(input.step || '1', 10) || 1;
        var min = parseInt(input.min || '1', 10) || 1;
        var v = parseInt(input.value, 10) || min;
        v = b.dataset.dir === 'up' ? v + step : Math.max(min, v - step);
        input.value = v;
      });
    });
  });

  /* ---------- Sort dropdown (collection) ---------- */
  var sort = document.querySelector('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    window.location.href = url.toString();
  });

  /* ---------- Inject FAQPage JSON-LD (AEO) from rendered FAQ ---------- */
  var faq = document.querySelector('[data-faq]');
  if (faq) {
    var qa = [];
    faq.querySelectorAll('.faq__item').forEach(function (it) {
      var q = it.querySelector('.faq__q');
      var a = it.querySelector('.faq__a');
      if (q && a) qa.push({ '@type': 'Question', name: q.textContent.trim(), acceptedAnswer: { '@type': 'Answer', text: a.textContent.trim() } });
    });
    if (qa.length) {
      var s = document.createElement('script');
      s.type = 'application/ld+json';
      s.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: qa });
      document.head.appendChild(s);
    }
  }

  /* ---------- Product gallery (desktop thumbs -> main) ---------- */
  (function () {
    var gallery = document.querySelector('.gallery');
    if (!gallery) return;
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    var mains = gallery.querySelectorAll('[data-main]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.getAttribute('data-thumb');
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
        mains.forEach(function (m) { m.classList.toggle('is-active', m.getAttribute('data-main') === i); });
      });
    });
  })();

  /* ---------- Product gallery (mobile dots sync) ---------- */
  (function () {
    var strip = document.querySelector('[data-gallery-mobile]');
    var dots = document.querySelector('[data-gallery-dots]');
    if (!strip || !dots) return;
    var spans = dots.querySelectorAll('span');
    strip.addEventListener('scroll', function () {
      var i = Math.round(strip.scrollLeft / strip.clientWidth);
      spans.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
    }, { passive: true });
  })();

  /* ---------- New arrivals carousel arrows ---------- */
  document.querySelectorAll('[data-arrivals]').forEach(function (sec) {
    var track = sec.querySelector('[data-arrivals-track]');
    var prev = sec.querySelector('[data-arrivals-prev]');
    var next = sec.querySelector('[data-arrivals-next]');
    if (!track) return;
    function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 14 : track.clientWidth * 0.5; }
    function update() {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    update();
  });

  /* ---------- Product variant picker (swatches / pills) ---------- */
  (function () {
    var root = document.querySelector('[data-product-root]');
    if (!root) return;
    var dataEl = root.querySelector('[data-variants]');
    var idInput = root.querySelector('[data-variant-id]');
    if (!dataEl || !idInput) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var addBtn = root.querySelector('[data-add-btn]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-opt]'));
    var selected = {};
    if (!groups.length) return;   /* single-variant product: leave server default */

    groups.forEach(function (group) {
      var pos = group.getAttribute('data-opt');
      var active = group.querySelector('[data-val].is-active') || group.querySelector('[data-val]');
      if (active) selected[pos] = active.getAttribute('data-val');
      group.querySelectorAll('[data-val]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('[data-val]').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          selected[pos] = btn.getAttribute('data-val');
          var chosen = group.querySelector('[data-chosen]');
          if (chosen) chosen.textContent = btn.getAttribute('data-val');
          update();
        });
      });
    });

    function match() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return String(opt) === String(selected[String(i + 1)]); });
      });
    }
    function update() {
      var v = match();
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) compareEl.textContent = v.compare || '';
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? (addBtn.getAttribute('data-add') || 'Add to cart') : (addBtn.getAttribute('data-soldout') || 'Sold out');
      }
    }
    update();
  })();
})();
